import FetchResponses from "../../../models/FetchResponses";
import React, { Component } from "react";
import settings from "../../../settings";
import PageLoader from "../../GlobalComponents/PageLoader";
import Error from "../../PublicViews/Error";
import { Modal } from "antd";
import IconSelector from "../../GlobalComponents/IconSelector";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-pys-custom-build";

class Beneficios extends Component {
  confirm = Modal.confirm;
  constructor(props) {
    super(props);
    this.state = {
      changeIconModal: false,
      loading: false,
      open: false,
      error_message: "",
      bloque1: {
        titulo: "",
        data: {
          beneficios: [],
        },
        imagen: null,
      },
      bloque2: {
        titulo: "",
        data: {
          opciones: [],
        },
      },
      iconoNuevo: '',
      pasoEnEdicion: {}
    };
  }

  handleClose = () => {
    this.setState({ error_message: "", open: false });
  };

  componentDidMount() {
    this.getBenefits();
  }

  getBenefits() {
    this.setState({ loading: true });
    let url = settings.backend.benefits;
    fetch(url, {
      method: "GET",
      headers: settings.headers_super_auth,
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        const bloque1 = response.find((item) => item.name === "bloque1");
        const bloque2 = response.find((item) => item.name === "bloque2");

        this.setState({ bloque1, bloque2, loading: false });
      })
      .catch(this.failureDataResponse);
  }

  saveBenefits = (benefit, data) => {
    this.setState({ loading: true });
    let url = settings.backend.benefits + benefit + "/";
    fetch(url, {
      method: "put",
      headers: settings.headers_super_auth,
      body: JSON.stringify(data),
    })
      .then(FetchResponses.processResponse)
      .then((response) => {
        this.getBenefits();
      })
      .catch(this.failureDataResponse);
  };

  failureDataResponse = (error) => {
    this.setState({ loading: false });
  };

  handleBloque1Change = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      bloque1: {
        ...prevState.bloque1,
        [name]: value,
      },
    }));
  };

  handleBeneficioChange = (index, field, value) => {
    const nuevosBeneficios = [...this.state.bloque1.data.beneficios];
    nuevosBeneficios[index][field] = value;
    this.setState((prevState) => ({
      bloque1: {
        ...prevState.bloque1,
        data: {
          beneficios: nuevosBeneficios,
        },
      },
    }));
  };

  eliminarBeneficio = (index) => {
    let _this = this;
    this.confirm({
      title: "Alkomprar te informa.",
      content: "¿Seguro que quiere eliminar el beneficio?",
      okText: "Continuar",
      onOk() {
        const nuevosBeneficios = _this.state.bloque1.data.beneficios.filter(
          (_, i) => i !== index
        );
        _this.setState((prevState) => ({
          bloque1: {
            ...prevState.bloque1,
            data: {
              beneficios: nuevosBeneficios,
            },
          },
        }));
      },
      onCancel() {},
    });
  };

  agregarBeneficio = () => {
    this.setState((prevState) => ({
      bloque1: {
        ...prevState.bloque1,
        data: {
          beneficios: [...prevState.bloque1.data.beneficios, { texto: "" }],
        },
      },
    }));
  };

  guardarBloque1 = () => {
    if (this.state.bloque1.data.beneficios.length < 3) {
      this.setState({
        open: true,
        error_message: "Debe tener al menos 3 beneficios",
      });
      return;
    }
    this.saveBenefits("bloque1", this.state.bloque1);
  };

  guardarBloque2 = () => {
    let opciones = this.state.bloque2.data.opciones

    if(!opciones[0].activo && !opciones[1].activo) {
      this.setState({
        open: true,
        error_message: "Debe tener al menos una opción activa",
      });
      return;
    }


    let continueSave = true;

    if(opciones[0].activo) {
      opciones[0].pasos.map((paso) => {
        if(paso.texto == '') {
          this.setState({
            open: true,
            error_message: "El campo de texto es obligatorio en todos los pasos.",
          });
          continueSave = false
          return;
        }
      })

    }

    if(!continueSave) return;


    if(opciones[1].activo) {
      opciones[1].pasos.map((paso) => {
        if(paso.texto == '') {
          this.setState({
            open: true,
            error_message: "El campo de texto es obligatorio en todos los pasos",
          });
          continueSave = false
          return;
        }
      })

    }
    

    if(!continueSave) return;

    this.saveBenefits("bloque2", this.state.bloque2);
  };

  renderBloque1 = () => {
    return (
      <div style={{ width: "70%" }}>
        <h2>Bloque 1: Beneficios</h2>
        <div>
          <span className="carrusel--subtitle">Titulo</span>
          <input
            type="text"
            name="titulo"
            placeholder="Título (máx 30 caracteres)"
            maxLength={30}
            value={this.state.bloque1.titulo}
            onChange={this.handleBloque1Change}
            className="form-control"
          />
        </div>


        <div>
          <span className="carrusel--subtitle">Imagen (URL)</span>
          <input
            type="text"
            name="imagen"
            placeholder="Imagen (URL)"
            value={this.state.bloque1.imagen}
            onChange={this.handleBloque1Change}
            className="form-control"
          />
        </div>

        <div>
          <span className="carrusel--subtitle">Beneficios</span>
          {this.state.bloque1.data.beneficios.map((beneficio, index) => (
            <div key={index} style={{ marginBottom: 10, position: "relative" }}>
              <input
                type="text"
                placeholder="Texto del beneficio (máx 500)"
                maxLength={500}
                value={beneficio.texto}
                onChange={(e) =>
                  this.handleBeneficioChange(index, "texto", e.target.value)
                }
                className="form-control"
                style={{
                  width: "100%",
                  paddingRight: "80px",
                }}
              />
              <button
                onClick={() => this.eliminarBeneficio(index)}
                style={{
                  position: "absolute",
                  right: "5px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  height: "70%",
                  padding: "4px 10px",
                  background: "#dc3545",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Eliminar
              </button>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
          <button onClick={this.agregarBeneficio} className="btn btn-secondary">
            Agregar Beneficio
          </button>
          <button onClick={this.guardarBloque1} className="btn btn-primary">
            Guardar Bloque 1
          </button>
        </div>
      </div>
    );
  };

  handlePasoTextoChange = (idx, pasoIdx, newText) => {
    const opciones = [...this.state.bloque2.data.opciones];
    opciones[idx].pasos[pasoIdx].texto = newText;
  
    this.setState({
      bloque2: {
        ...this.state.bloque2,
        data: { opciones },
      },
    });
  };

  renderBloque2 = () => {
    return (
      <div style={{ width: "70%" }}>
        <h2>Bloque 2: Opciones</h2>

        <div>
          <span className="carrusel--subtitle">Titulo</span>
          <input
            type="text"
            name="titulo"
            placeholder="Título del bloque 2 (máx 30)"
            maxLength={30}
            value={this.state.bloque2.titulo}
            onChange={(e) =>
              this.setState({
                bloque2: { ...this.state.bloque2, titulo: e.target.value },
              })
            }
            className="form-control"
          />
        </div>


        {this.state.bloque2.data.opciones.map((opcion, idx) => (
          <div
            key={idx}
            style={{
              marginBottom: 20,
              border: "1px solid #ccc",
              padding: 20,
              margin: "30px 0",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              borderRadius: "20px",
            }}
          >
            <label>
              <input
                type="checkbox"
                checked={opcion.activo}
                onChange={(e) => {
                  const opciones = [...this.state.bloque2.data.opciones];
                  opciones[idx].activo = e.target.checked;
                  this.setState({
                    bloque2: { ...this.state.bloque2, data: { opciones } },
                  });
                }}
              />{" "}
              Toggle Opción {idx + 1}
            </label>
            {opcion.activo && (
              <div>
                <span
                  className="carrusel--subtitle"
                  style={{ margin: "20px 0" }}
                >
                  Titulo
                </span>
                <input
                  type="text"
                  placeholder={`Título Opción ${idx + 1}`}
                  value={opcion.titulo}
                  onChange={(e) => {
                    const opciones = [...this.state.bloque2.data.opciones];
                    opciones[idx].titulo = e.target.value;
                    this.setState({
                      bloque2: { ...this.state.bloque2, data: { opciones } },
                    });
                  }}
                  className="form-control"
                />
                {opcion.pasos.map((paso, pasoIdx) => (
                  <div key={pasoIdx} style={{ marginBottom: 10 }}>
                    <span
                      className="carrusel--subtitle"
                      style={{ margin: "20px 0" }}
                    >
                      Paso {pasoIdx + 1}{" "}
                    </span>

                    <div style={{ marginBottom: 10, position: "relative" }}>
                      <input
                        type="text"
                        placeholder={`Icono`}
                        readOnly
                        value={paso.icono}
                        className="form-control"
                        style={{
                          width: "100%",
                          paddingRight: "80px", // espacio para el botón dentro del input
                        }}
                      />
                      <button
                        style={{
                          position: "absolute",
                          right: "5px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          height: "70%",
                          padding: "4px 10px",
                          background: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}

                        onClick={() => { this.setState({changeIconModal: true,  pasoEnEdicion: {
                          opcionIndex: idx,  
                          pasoIndex: pasoIdx
                        }})}}
                      >
                        Cambiar Icono
                      </button>
                    </div>

                    <CKEditor
                      editor={ClassicEditor}
                      config={{
                        toolbar: ["underline", "bold", "italic", "link", "undo", "redo"],
                        image: {},
                        table: {},
                        extraPlugins: [],
                      }}
                      data={paso.texto}
                      onReady={(editor) => {}}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.handlePasoTextoChange(idx, pasoIdx, data);
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <button onClick={this.guardarBloque2} className="btn btn-primary">
          Guardar Bloque 2
        </button>
      </div>
    );
  };
  closeModal = () => {
    console.log("Close modal");
  };

  cancelChangeIcon = () => {
    this.setState({ changeIconModal: false })
  }

  guardarIcono  = (event) => {
    let idx = this.state.pasoEnEdicion.opcionIndex
    let pasoIdx = this.state.pasoEnEdicion.pasoIndex

    const opciones = [...this.state.bloque2.data.opciones];
    opciones[idx].pasos[pasoIdx].icono = this.state.iconoNuevo;
    
    this.setState({
      changeIconModal: false,
      iconoNuevo: '',
      bloque2: {
        ...this.state.bloque2,
        data: { opciones },
      },
    });
  }

  cambiarIcono = (event) => {
    const { value } = event.target;
    this.setState({ iconoNuevo: value})
  }
  render() {
    return (
      <div
        style={{
          padding: 20,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {this.renderBloque1()}

        <hr style={{ margin: "30px 0" }} />

        {this.renderBloque2()}

        {this.state.loading && <PageLoader />}

        <Error
          open={this.state.open}
          error_message={this.state.error_message}
          handleClose={() => this.handleClose()}
        />

        <Modal
          visible={this.state.changeIconModal}
          onCancel={this.closeModal}
          closable={false}
          footer={
            this.state.loading ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              [
                <button
                  key="cancel"
                  className="btn btn-secondary"
                  onClick={() => this.cancelChangeIcon()}
                >
                  Cancelar
                </button>,
                <button
                  key="confirm"
                  className="btn btn-primary"
                  type="button"
                  onClick={this.guardarIcono}
                >
                  Guardar
                </button>,
              ]
            )
          }
        >
          <IconSelector value={this.state.icon} onChange={this.cambiarIcono} />
        </Modal>
      </div>
    );
  }
}

export default Beneficios;
